const SUPPORTED_LOCALES = ['da', 'en', 'sv', 'no'];
const DEFAULT_LOCALE = 'en';
// Shopify uses both 'no' and 'nb' for Norwegian depending on store setup.
const shopLocale = Shopify.locale === 'nb' ? 'no' : Shopify.locale;
const locale = SUPPORTED_LOCALES.includes(shopLocale) ? shopLocale : DEFAULT_LOCALE;

const TRANSLATION_NOTICE = {
  da: 'Præcise billeder og vægte vises ved midnat på releasedagen.',
  en: 'Exact photos and weights are revealed at midnight on the release day.',
  sv: 'Exakta bilder och vikter visas vid midnatt på releasedagen.',
  no: 'Nøyaktige bilder og vekter vises ved midnatt på releasedagen.',
};

class DtMediaEmbargo extends HTMLElement {
  connectedCallback() {
    this.embargoEnd = new Date(this.getAttribute('until'));
    if (Number.isNaN(this.embargoEnd.getTime())) return;

    this.innerHTML = `<p style="font-size: 1.3rem; color: rgba(var(--color-foreground), 0.75); margin: 1rem 0;">${TRANSLATION_NOTICE[locale]}</p>`;

    this.checkId = setInterval(() => this.reloadIfEnded(), 1000);
    this.onVisible = () => this.reloadIfEnded();
    document.addEventListener('visibilitychange', this.onVisible);
    this.reloadIfEnded();
  }

  disconnectedCallback() {
    if (this.checkId) clearInterval(this.checkId);
    document.removeEventListener('visibilitychange', this.onVisible);
  }

  reloadIfEnded() {
    if (new Date() < this.embargoEnd) return;
    if (DtMediaEmbargo.reloading) return;
    DtMediaEmbargo.reloading = true;
    // Cache-busting param so a stale CDN copy of the embargoed page isn't served back
    const url = new URL(window.location.href);
    url.searchParams.set('_embargo', Date.now().toString());
    window.location.replace(url.toString());
  }
}

customElements.define('dt-media-embargo', DtMediaEmbargo);
